const mapPromptToSettings = (prompt, productList, styleList) => {
  const product = productList.find((product) => product.lora_model_name === prompt.model);
  const keywords = prompt.keywords.join(",");
  const style = styleList.find((style) => style.keywords === keywords);
  return {
    productModel: product ? product.name : "",
    promptText: prompt.prompt,
    imageStyle: style ? style.name : "",
    aspectRatio: prompt.aspectRatio,
  };
};

const downloadImage = (src, filename = "generated_image.png") => {
  // 创建一个<a>元素
  const link = document.createElement("a");
  link.href = src; // 设置图片的URL
  link.download = "downloaded-image.png"; // 设置下载的文件名

  // 这一步是必须的，因为我们需要将链接元素添加到页面中去才能触发点击
  document.body.appendChild(link);
  link.click(); // 编程方式点击链接

  // 下载后立即移除元素
  document.body.removeChild(link);
};

export { mapPromptToSettings, downloadImage };
